import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import add_circle from './../assets/images/add_circle.svg';
import AddFarmModal from '../modal/AddFarmModal';
import useOutsideClick from '../hooks/useOutsideClick';

function SearchSelectFarms({ refe, inputValue, farmList, setInputValue, refetch, isPopover, setIsPopover }) {
    const { t } = useTranslation();

    const [searchInput, setSearchInput] = useState('');

    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isEditItem, setIsEditItem] = useState(undefined);
    const searchInputRef = useRef(null);

    const handleSearchChange = (e) => {
        setSearchInput(e.target.value);
    };

    const handlefarmClick = (selectedfarm) => {
        setInputValue({
            ...inputValue,
            farm: selectedfarm
        });
        setIsPopover(false);
        setSearchInput('');
    };

    const handleClosePopup = async (data) => {
        setPopupOpen(false);
        setIsEdit(false);
        setIsEditItem(undefined);
        if (data.isRefresh && data.farm) {
            refetch();
            setInputValue({
                ...inputValue,
                farm: data.farm
            });
        }
    }

    useEffect(() => {
        setSearchInput('');

        if (isPopover && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    
        return () => {
            setSearchInput('');
        }
    }, [isPopover])
    
    return (<>
        <div className="col-span-1">
            <label className="font-medium text-[14px] text-[#6F6F6F] mb-[6px]">
                {t('farm')}
            </label>
            <div className='flex gap-4'>
                <div className='relative w-full'>
                    <div className='text-input flex items-start justify-center flex-col cursor-pointer mt-[5px] w-full min-h-[50px] px-[19px] text-[16px] font-[500] text-secondary rounded-[8px] bg-[#F5F5F5]'
                        onClick={(e) => { 
                           
                            e.stopPropagation(); 
                             setIsPopover(prev => !prev)}}>
                        {inputValue?.farm?.farmName ? <>
                            <span className='text-[14px]'> {inputValue?.farm?.farmName}</span>
                            <small className='break-all'>{inputValue?.farm?.address}</small>
                        </> : t('select_farm')}

                    </div>
                    {isPopover && (
                        <div className='absolute w-full p-3 rounded-[8px] z-[99] bg-white border' ref={refe}>
                            <input
                                ref={searchInputRef}
                                type='text'
                                placeholder={t('search_label')}
                                className='border border-primary rounded-[5px] p-[5px] mb-[10px] w-full outline-none'
                                value={searchInput}
                                onChange={handleSearchChange}
                            />
                            <div className=' max-h-[185px] overflow-auto'>
                                {farmList
                                    ?.filter(farm =>
                                        farm.farmName.toLowerCase().includes(searchInput.toLowerCase().trim())
                                    )
                                    .map(farm => (
                                        <div
                                            key={farm._id}
                                            className="flex items-start cursor-pointer p-1 hover:bg-gray-100 justify-start flex-col"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handlefarmClick(farm)
                                            }}
                                        >
                                            <span> {farm.farmName}</span>
                                            <small>{farm.address}</small>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className='flex items-center'>
                    <img src={add_circle} alt='Add'
                        className='cursor-pointer'
                        onClick={(e) => { 
                            e.stopPropagation();
                            setIsPopover(false); 
                            setPopupOpen(true)}
                        } 
                    />
                </div>
            </div>

        </div>

        <AddFarmModal
            isOpen={isPopupOpen}
            onClose={handleClosePopup}
            isEdit={isEdit}
            isEditItem={isEditItem}
            isFromOrder={true}
        ></AddFarmModal>
    </>
    )
}

export default SearchSelectFarms